import c1_state from "../model/C1_State";
import type { Rect } from "../types/C1_AppTypes";

export function clientToPlan(container: Element | null, clientX: number, clientY: number, view: Rect = c1_state.view) {
  const svg =
    container instanceof SVGSVGElement
      ? container
      : (container?.querySelector<SVGSVGElement>(":scope > .C1_planSvg") ??
        container?.closest(".C1_canvas")?.querySelector<SVGSVGElement>(":scope > .C1_planSvg"));
  const screenMatrix = svg?.getScreenCTM();
  if (!svg || !screenMatrix) return null;

  const point = new DOMPoint(clientX, clientY).matrixTransform(screenMatrix.inverse());
  return {
    x: point.x / c1_state.svgPx + view.x1,
    y: point.y / c1_state.svgPx + view.y1,
  };
}
